import {useQuery} from 'react-query';
import getPrepaymentSuggestion from 'services/myAd/getSuggestions/prepayment/getprepaymentSuggestion';

const useGetPrepaymentSuggestion = (guid: string) => {
  const {data, isLoading} = useQuery(
    ['prepayment-suggestion', guid],
    getPrepaymentSuggestion,
  );
  return {data, isLoading};
};

export default useGetPrepaymentSuggestion;
